import {Link} from '~/components/Link';
import * as marked from 'marked';

import {SerializeFrom} from '@shopify/remix-oxygen';
export interface CollectionHero {
  title: string;
  height?: 'full';
  loading?: 'eager' | 'lazy';
  imageUrl: string;
  cta_link?: string;
  cta_label?: string;
  rich_text?: string;
}
import _ from 'lodash';
import {isMarkdown, toHTML} from '~/utils';
import {isMediaVideo, renderMarkDown} from '~/lib/utils';
const HeroBanner = ({
  title,
  imageUrl,
  cta_link,
  cta_label,
  rich_text='',
}: SerializeFrom<CollectionHero>) => {
  const [isVideo, ext] = isMediaVideo(imageUrl);
  const heroStyles: any = {
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    paddingTop: '28%',
    paddingBottom: '25px',
  };
  if (!isVideo) {
    heroStyles['backgroundImage'] = `url(${imageUrl})`;
    heroStyles['paddingTop'] = '28%';
  }
  return (
    <>
      <div
        className={`bigdata-analytics-banner ${
          isVideo ? 'video-container' : ''
        }`}
        style={{...heroStyles}}
      >
        <div className="container">
          {isVideo ? (
            <video id="bgvid" playsInline autoPlay muted loop>
              <source src={imageUrl} type={`video/${ext}`} />
            </video>
          ) : null}
          <div className="bigdata-analytics-content">
            <h1>{title}</h1>
            <div
              dangerouslySetInnerHTML={{
                __html: isMarkdown(rich_text)
                  ? renderMarkDown(rich_text)
                  : toHTML(rich_text),
              }}
              className="prose dark:prose-invert"
            />
            {cta_link && cta_link !== ' ' ? (
              <Link to={cta_link || ''} className="btn btn-primary cta">
                {cta_label}
              </Link>
            ) : null}

            <div className="mb-5" />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroBanner;
